define('evicommon/search/search.adapter',['require','exports','module','../state/param.adapter'],function(require, exports, module) {
  //prettier-ignore
  var ParamAdapter = require('../state/param.adapter');

  var SearchAdapter = ParamAdapter.extend({
    options: {
      //traditional param
      searchParam: 'search',

      // Search service params
      queryParam: 'query',
      fieldParam: 'fields',
    },

    constructor: function(filterObj, options) {
      this.isSearchServiceFilter = filterObj.isSearchServiceFilter;
      this.filters = filterObj;
      ParamAdapter.call(this, {}, options);
      this.syncFilters();
      this.filters.on('add remove change reset', this.syncFilters, this);
    },

    syncFilters: function() {
      if (this.isSearchServiceFilter) {
        this.syncSearchServiceFilters();
      } else {
        this.syncTraditionalFilters();
      }
    },

    syncTraditionalFilters: function() {
      var param = this.options.searchParam;

      this.model.set(param, this.filters.toQuery());
    },

    syncSearchServiceFilters: function() {
      //prettier-ignore
      var param            = this.options.queryParam,
          additionalParams = this.filters.get('additionalParams');

      //clear out any previous parameter configurations
      this.model.clear();
      this.model.set(param, this.filters.get('query'));
      this.model.set(this.options.fieldParam, this.filters.get('queryFields'));

      //if any additional parameters have been defined, we add those in here
      for (key in additionalParams) {
        this.model.set(key, additionalParams[key]);
      }
    },
  });

  module.exports = SearchAdapter;
});

